import React, { useState, useEffect } from 'react';

const ProgressBar: React.FC = () => {
  const [progress, setProgress] = useState<number>(0);

  // Function to simulate progress in steps
  const simulateProgress = () => {
    if (progress < 100) {
      setProgress((prev) => {
        if (prev < 25) return 25;
        if (prev < 50) return 50;
        if (prev < 75) return 75;
        return 100;
      });
    }
  };

  // Use `useEffect` to simulate progress
  useEffect(() => {
    const interval = setInterval(simulateProgress, 1000); // Update progress every 1000ms

    // Clear the interval once progress reaches 100%
    if (progress === 100) {
      clearInterval(interval);
    }

    return () => clearInterval(interval); // Cleanup the interval when the component unmounts
  }, [progress]); // Re-run useEffect whenever `progress` changes

  return (
    <div style={{width:'100%'}}>
      {/* Display markers for 0%, 25%, 50%, and 100% */}
      <div className='persetTital'>
        <span>0%</span>
        <span>25%</span>
        <span>50%</span>
        <span>75%</span>
        <span>100%</span>
      </div>
      <div className="barBackgroundMain">
        <div className='barBackground'>
          <div
            style={{
              height: '100%',
              width: `${progress}%`,
              background: 'var(--secondary, linear-gradient(135deg, #03ECD9 0%, #6FB2E9 100%))',
              borderRadius: '5px',
              transition: 'width 1s ease-in-out',
              position: 'relative', // Container div must have position relative for absolute positioning to work
              display: 'flex',
              alignItems: 'center', // Vertically center the text
              justifyContent: 'center', // Horizontally center the text
            }}
          >
            {/* Display progress percentage */}
            <p className='progresValue' style={{ position: 'absolute', zIndex: 1, right: '-2px' }}>
              {progress}%
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
